'use client';

import { useEffect, useState } from 'react';
import LocalStorageRepository from '@framework/browser/storage/LocalStorageRepository';
import { getContainer } from '@framework/di/getContainer';
import { useSessionContext } from '@users/session/SessionContext';
import { DataroomTenant } from '@dataroom/tenant/DataroomTenant';
import { useDataroomTenantContext } from '@dataroom/tenant/DataroomTenantContext';

interface IHideDeactivated {
  isHideDeactivated: boolean,
  isHideDeactivatedRestored: boolean,
  setIsHideDeactivated: (isHideDeactivated: boolean) => void,
}

const getStorageKey = (userId: number | string, tenant: DataroomTenant): string => (
  `dataroom/myDatarooms/hideDeactivated/${ userId }/${ tenant }`
);

const useHideDeactivated = (): IHideDeactivated => {
  const localStorageRepository = getContainer().get(LocalStorageRepository);
  const { tenant } = useDataroomTenantContext();
  const { currentUser, currentUserFetching } = useSessionContext();
  const [isHideDeactivated, setIsHideDeactivatedState] = useState<boolean>(false);
  const [isHideDeactivatedRestored, setIsHideDeactivatedRestored] = useState<boolean>(false);

  const storageKey = currentUser?.id ? getStorageKey(currentUser.id, tenant) : null;

  useEffect(() => {
    if (currentUserFetching) {
      return;
    }

    setIsHideDeactivatedState(!!storageKey && localStorageRepository.getItem(storageKey) === true);
    setIsHideDeactivatedRestored(true);
  }, [storageKey, currentUserFetching]);

  const setIsHideDeactivated = (value: boolean): void => {
    setIsHideDeactivatedState(value);

    if (storageKey) {
      localStorageRepository.setItem(storageKey, value);
    }
  };

  return {
    isHideDeactivated,
    isHideDeactivatedRestored,
    setIsHideDeactivated,
  };
};

export default useHideDeactivated;
